(() => {
  const DEBUG = true;
  const ALT_PREFIX = 'optis:';
  const ALLOWED_HANDLES = [
    'rama-elysio-finisaj-lemn-clasic',
    'rama-finisaj-premium'
  ];
  let lastValue = null;

  function log() {
    if (!DEBUG) return;
    console.log('[OPTIS IMG]', ...arguments);
  }

  function normalize(v) {
    return (v || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isAllowedProduct() {
    const path = window.location.pathname || '';
    return ALLOWED_HANDLES.some((handle) => path.includes('/products/' + handle));
  }

  if (!isAllowedProduct()) {
    return;
  }

  function getCurrentTextureValue() {
    const el = document.querySelector('.po-selected-swatch .swatch_value, .po-selected-swatch .po-value');
    return el ? el.textContent.trim() : null;
  }

  function getProductRoot() {
    return (
      document.querySelector('media-gallery') ||
      document.querySelector('product-info') ||
      document.querySelector('[id^="MainProduct-"]') ||
      document.querySelector('.product') ||
      document
    );
  }

  function getMediaItems(root) {
    if (!root) return [];
    return Array.from(
      root.querySelectorAll('[data-media-id], .product__media-item, .slider__slide')
    ).filter((item) => item.querySelector('img'));
  }

  function getMediaId(item) {
    return item?.dataset?.mediaId || item?.getAttribute('data-media-id') || null;
  }

  function findMediaItemByValue(root, value) {
    const targetAlt = normalize(ALT_PREFIX + value);
    const items = getMediaItems(root);

    for (const item of items) {
      const img = item.querySelector('img');
      if (!img) continue;

      const alt = normalize(img.getAttribute('alt'));
      if (alt === targetAlt) {
        log('matched media item for', value, item, 'mediaId:', getMediaId(item));
        return item;
      }
    }

    log('no media item found for', value, 'expected alt:', targetAlt);
    return null;
  }

  function findThumbnailByMediaItem(root, mediaItem) {
    if (!root || !mediaItem) return null;

    const mediaId = getMediaId(mediaItem);
    const mediaImg = mediaItem.querySelector('img');
    const mediaAlt = normalize(mediaImg?.getAttribute('alt'));

    log('find thumbnail for mediaId:', mediaId, 'alt:', mediaAlt);

    if (mediaId) {
      const liByTarget = root.querySelector(`li[data-target="${mediaId}"]`);
      if (liByTarget) {
        const btn = liByTarget.querySelector('button.thumbnail, button');
        if (btn) {
          log('thumbnail found by li[data-target]');
          return btn;
        }
      }
    }

    if (mediaAlt) {
      const thumbImg = Array.from(
        root.querySelectorAll('.thumbnail-list img, .thumbnail img, li img')
      ).find((img) => normalize(img.getAttribute('alt')) === mediaAlt);

      if (thumbImg) {
        const btn = thumbImg.closest('button.thumbnail, button');
        if (btn) {
          log('thumbnail found by alt match');
          return btn;
        }
      }
    }

    return null;
  }

  function clearActiveThumb(root) {
    const thumbs = Array.from(
      root.querySelectorAll('.thumbnail, .thumbnail-list__item button, li[data-target] button')
    );

    thumbs.forEach((btn) => {
      btn.classList.remove('is-active', 'active');
      btn.removeAttribute('aria-current');

      const li = btn.closest('li');
      if (li) {
        li.classList.remove('slider__slide--active', 'is-active', 'active');
        li.setAttribute('aria-current', 'false');
        li.setAttribute('aria-selected', 'false');
      }
    });
  }

  function setActiveThumb(btn) {
    if (!btn) return;

    btn.classList.add('is-active', 'active');
    btn.setAttribute('aria-current', 'true');

    const li = btn.closest('li');
    if (li) {
      li.classList.add('slider__slide--active', 'is-active', 'active');
      li.setAttribute('aria-current', 'true');
      li.setAttribute('aria-selected', 'true');
    }
  }

  function fallbackSwapMainImage(root, mediaItem) {
    const sourceImg = mediaItem.querySelector('img');
    const mainImg =
      root.querySelector('.product__media img') ||
      root.querySelector('.product-media-container img') ||
      root.querySelector('#GalleryViewer img') ||
      root.querySelector('media-gallery img');

    if (!sourceImg || !mainImg) {
      log('fallback main image swap failed');
      return;
    }

    if (sourceImg.currentSrc) mainImg.src = sourceImg.currentSrc;
    if (sourceImg.getAttribute('srcset')) mainImg.setAttribute('srcset', sourceImg.getAttribute('srcset'));
    if (sourceImg.getAttribute('sizes')) mainImg.setAttribute('sizes', sourceImg.getAttribute('sizes'));
    if (sourceImg.alt) mainImg.alt = sourceImg.alt;

    log('fallback main image updated');
  }

  function activateMediaByValue(value) {
    const root = getProductRoot();
    if (!root || !value) return;

    const mediaItem = findMediaItemByValue(root, value);
    if (!mediaItem) return;

    const thumb = findThumbnailByMediaItem(root, mediaItem);

    if (thumb) {
      clearActiveThumb(root);
      setActiveThumb(thumb);
      thumb.click();
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      log('thumbnail clicked for value:', value);
      return;
    }

    log('no thumbnail found, using fallback image swap');
    mediaItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    fallbackSwapMainImage(root, mediaItem);
  }

  function preloadOptisImages() {
    const urls = new Set();

    Array.from(document.querySelectorAll('img')).forEach((img) => {
      const alt = normalize(img.alt);
      if (!alt.startsWith('optis:')) return;

      const src = img.currentSrc || img.src;
      if (src) urls.add(src);

      const srcset = img.getAttribute('srcset');
      if (srcset) {
        srcset.split(',').forEach((entry) => {
          const url = entry.trim().split(' ')[0];
          if (url) urls.add(url);
        });
      }
    });

    urls.forEach((url) => {
      const i = new Image();
      i.src = url;
    });

    log('preloaded optis images:', urls.size);
  }

  function checkSelectedValue() {
    const value = getCurrentTextureValue();
    if (!value) return;

    if (value !== lastValue) {
      lastValue = value;
      log('detected texture value:', value);
      activateMediaByValue(value);
    }
  }

  function init() {
    preloadOptisImages();
    checkSelectedValue();
    setInterval(checkSelectedValue, 250);
    log('init done for', window.location.pathname);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();